import Vue from 'vue';
import Router, {RawLocation} from 'vue-router';
import {getStorage} from '@/utils/storage';
import routes from '@/routes';

Vue.use(Router);

// 解决跳转重复路由时报错的问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location: RawLocation) {
  // @ts-ignore: ts 无法解释 catch
  return originalPush.call(this, location).catch((err: Error) => err);
};

const baseUrl = process.env.BASE_URL;

const router = new Router({
  mode: 'history',
  base: baseUrl,
  routes,
});

// 前置路由守卫
router.beforeEach((to, from, next) => {
  // 判断 token 是否已过期, expire 存在，则 token 一定存在
  const expire = parseInt(getStorage('expire'), 10);
  const expired = isNaN(expire) || (expire < Date.now());

  // 已登录时，不允许再访问登录页
  if (!expired && to.name === 'login') {
    return next({name: 'home'});
  }

  // 未登录时，不允许访问需要鉴权的页面(ignoreAuth === true 表示忽略鉴权)
  if (expired && !to?.meta?.ignoreAuth) {
    return next({name: 'login'});
  }

  next();
});

export default router;
